import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';

import { LoggerService } from '../../services/logger.service';
import { APIError } from '../../../shared/utils/error';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const logService = inject(LoggerService);
  const interceptor = next(req).pipe(
    catchError((errorResponse: HttpErrorResponse) => {
      // A client-side or network error occurred.
      let error;
      if (errorResponse.error instanceof ErrorEvent) {
        error = errorResponse;
      }
      // The backend returned an unsuccessful response status code (400 - 599).
      else {
        const { code, message } = errorResponse.error;
        error = new APIError(code, message);
      }

      // Log the error
      logService.log(error);
      
      // Rethrow the error.
      throw error;
    })
  );

  return interceptor;
}
